/** All store keys in system */
export const STORE_KEYS = {
    MODULES: {
      ROUTING: 'routerReducer',
      EXAMPLE: 'example',
    }
  };
